module.exports = __webpack_public_path__ + "img/propertysystem4.5ca685fb.png";